import { getVNodeFactory } from "../../../lib/renderer/utils";
import { isDumbElement } from "../../../lib/utils/browser";
import { isInsideRect } from "../../../lib/utils/styling";
/** 如果当前组件是一个容器，需要二次检查，是不是遇到了这穿透的情况 */
export function deepCompPathCapture(compPath, ev, designer) {
  var _factory$children;
  // ------------------------
  // DumbElement，从浏览器透出来的事件是不完整的（比如禁用的输入框无法提供鼠标事件、只读输入框的拖拽有问题）
  // 在样式里，把这些组件 pointer-events 设置为 none 了，然后他们的鼠标事件会被穿透到父节点上
  // 因此，如果当前组件是一个容器，需要二次检查，是不是遇到了这穿透的情况
  // （例如：一个“行”组件里，有一个 disabled 按钮，由于样式，导致事件会落在 行 上，而不是按钮）
  const renderer = designer.renderer;
  const factory = getVNodeFactory(renderer, compPath);
  factory === null || factory === void 0 || (_factory$children = factory.children) === null || _factory$children === void 0 || _factory$children.some(child => {
    var _renderer$getRefByPat;
    const instEl = (_renderer$getRefByPat = renderer.getRefByPath(child.compPath)) === null || _renderer$getRefByPat === void 0 ? void 0 : _renderer$getRefByPat.$el;
    if (!isDumbElement(instEl)) return false;
    if (!isInsideRect(ev.clientX, ev.clientY, instEl.getBoundingClientRect())) return false;
    compPath = child.compPath;
    return true;
  });
  return compPath;
}
//# sourceMappingURL=compCapture.js.map
